import { call, put, select, takeEvery } from 'redux-saga/effects';
import api from '../../utils/api';
import { GET_CARS_REQUEST, GET_CAR_REQUEST } from '../constants';
import {
  getCarsStart,
  getCarsSuccess,
  getCarsFail,
  getCarStart,
  getCarSuccess,
  getCarFail,
} from '../actions/cars';
import { setError } from '../actions/error';
import { selectorDealer } from '../selectors/options';

export function* getCars(action) {
    try {
    const currentDealer = yield select(selectorDealer);
    yield put(getCarsStart());
    const cars = yield call(api.cars.getCars, currentDealer, action.payload);
    yield put(getCarsSuccess(cars.data));
  } catch (error) {
    yield put(getCarsFail());
    yield put(setError(error));
  }
}

export function* getCar(action) {
  try {
    const currentDealer = yield select(selectorDealer);
    yield put(getCarStart());
    const car = yield call(api.cars.getCar, currentDealer, action.payload);
    yield put(getCarSuccess(car));
  } catch (error) {
    yield put(getCarFail());
    yield put(setError(`Could Not Find Car ${action.payload}`));
  }
}

export function* carsSaga() {
  yield takeEvery(GET_CARS_REQUEST, getCars);
  yield takeEvery(GET_CAR_REQUEST, getCar);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/cars.js